import { IUserLoyaltyEnrollment } from '~api/interfaces/ILoyaltyEnrollmentResponse';

export const UserEnrollment = (loyaltyEnrollmentData: IUserLoyaltyEnrollment) => {
    const { birthdayDay, birthdayMonth, loyaltyEnrolledSource, acceptedLoyaltyTerms } =
        loyaltyEnrollmentData;
    const birthDayInfo = birthdayDay ? `birthdayDay: ${birthdayDay} ,` : '';
    const birthMonthInfo = birthdayMonth ? `birthdayMonth: ${birthdayMonth} ,` : '';
    const userEnrollment = `mutation {
        enrollUser(
           user: {
              acceptedLoyaltyTerms: ${acceptedLoyaltyTerms},
              lastSource: "${loyaltyEnrolledSource}",
              action: "enroll",
              ${birthDayInfo}
              ${birthMonthInfo}
           }
        )
        {
            lastSource
            acceptedLoyaltyTerms
            loyaltyActiveFlag
        }
     }
    `;

    return userEnrollment;
};
